(() => {
  if (customElements.get('coin-cart-recommendations')) return;
  customElements.define('coin-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const priority = [...this.querySelectorAll('template[data-priority]')];
      const rest = [...this.querySelectorAll('template:not([data-priority])')];
      for (let i = rest.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [rest[i], rest[j]] = [rest[j], rest[i]];
      }
      const selected = [...priority, ...rest].slice(0, 2);
      this.querySelector('[data-recommendations]').replaceChildren(...selected.map(t => t.content.cloneNode(true)));
      this.hidden = selected.length === 0;
    }
  });
})();
